// extracted by mini-css-extract-plugin
module.exports = {"Bold":"UserDeleteAccountForm_Bold__XB2yn","Error":"UserDeleteAccountForm_Error__2-zlS"};